module.exports = __webpack_public_path__ + "static/img/T7385.947357fd.png";